import { default as calculationConsents } from './consents';

export const consents = {
  ...calculationConsents,
};
